import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpatialAudioOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"spatial_audio_off"}/>
}
